import { render, staticRenderFns } from "./NewTicketDialog.vue?vue&type=template&id=2e157a72&scoped=true&"
import script from "./NewTicketDialog.vue?vue&type=script&lang=js&"
export * from "./NewTicketDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e157a72",
  null
  
)

export default component.exports